import React from "react";
import { getConfidenceBadgeColors } from "./caseSummaryUtils";

interface StatusClassificationRowProps {
  responseStatus?: string | null;
  classification?: string | null;
  confidence?: string | null;
}

/**
 * Displays the Response Status and Classification cards side by side,
 * with an optional confidence badge on the classification card.
 */
const StatusClassificationRow: React.FC<StatusClassificationRowProps> = ({
  responseStatus,
  classification,
  confidence,
}) => {
  const badgeColors = confidence ? getConfidenceBadgeColors(confidence) : null;

  return (
    <div className="flex gap-4">
      <div className="flex w-1/2 flex-col gap-2 rounded-[10px] border border-[#E6E6E6] bg-white p-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#5C5C5C]">
          Response Status
        </p>
        <p className="text-sm text-[#1F1F1F]">{responseStatus || "-"}</p>
      </div>
      <div className="flex w-1/2 flex-col rounded-[10px] border border-[#E6E6E6] bg-white p-4">
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-2">
            <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#5C5C5C]">
              Classification
            </p>
            <p className="text-sm text-[#1F1F1F]">{classification || "-"}</p>
          </div>
          {badgeColors && (
            <span
              className={`rounded px-1.5 py-0.5 text-[11px] font-bold ${badgeColors.bg} ${badgeColors.text}`}
            >
              {confidence}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusClassificationRow;
